export default __webpack_public_path__ + "static/media/monitor.a803cc86.svg";